export default class Modal {

    constructor(modalID) {
        this.modal = document.getElementById(modalID);
        this.body = document.getElementsByTagName('body')[0];

        this.initCloseButtons();
    }

    initCloseButtons() {
        const closeButtons = this.modal.querySelectorAll('.close-modal');

        closeButtons.forEach(close => {
            close.addEventListener('click', e => {
                e.preventDefault();
                this.close();
            });
        });

        document.addEventListener('click', e => {
            if (this.modal == e.target) {
                this.close();
            }
        });
    }

    open() {
        const modal = this.modal;

        modal.classList.add('open');
        this.body.classList.add('modal-open');

        window.setTimeout(function () {
            modal.classList.add('fade');
        }, 100);
    }

    close() {
        const modal = this.modal;

        modal.classList.remove('fade');
        this.body.classList.remove('modal-open');

        window.setTimeout(function () {
            modal.classList.remove('open');
        }, 600);
    }
}
